import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["variantsContainer", "variantTemplate", "variantRow", "destroyField"]

  addVariant(event) {
    event.preventDefault()
    const template = this.variantTemplateTarget.innerHTML
    const newId = new Date().getTime()
    const newContent = template.replace(/NEW_VARIANT/g, newId)
    this.variantsContainerTarget.insertAdjacentHTML("beforeend", newContent)
  }

  removeVariant(event) {
    event.preventDefault()
    const row = event.target.closest("[data-nested-form-target='variantRow']")
    if (!row) return

    const destroyField = row.querySelector("[data-nested-form-target='destroyField']")

    if (destroyField && destroyField.value !== "") {
      // Check if it's a persisted record by looking for an id field
      const idField = row.querySelector("input[name*='[id]']")
      if (idField && idField.value) {
        // Existing record: mark for destruction and hide
        destroyField.value = "1"
        row.style.display = "none"
      } else {
        // New record: just remove from DOM
        row.remove()
      }
    } else {
      // No destroy field or empty: just remove
      row.remove()
    }
  }
}
